import { doGetExternalAppRequest } from "./ApiService";
import { baseHeaders } from "./Headers";

export function getTokenM4U(phone: any): Promise<any> {
  const url = "/customer/rechargeToken/"
    .concat(phone)
    .concat("/claro_flex/PRE_PAGO")
    .concat(`?gw-app-key=${process.env.VUE_APP_X_GW_APP_KEY}`);
  const headers = {
    ...baseHeaders,
    "x-uid": process.env.VUE_APP_X_UID,
    "x-customer-id": localStorage.getItem("x-customer-id")!,
    authorization: "Bearer ".concat(localStorage.getItem("x-access-token")!),
  };
  return doGetExternalAppRequest(url, headers);
}
